










































import Vue from "vue";
import ButtonRound from "@/components/atoms/ButtonRound.vue";
import HamburgerMenu, { Item } from "@/components/molecules/HamburgerMenu.vue";
import { stringify } from "csv/lib/sync";
import { format } from "date-fns";
import { Plot, SubPlot } from "@/lib/models/plot";
import { Dialog } from "@/lib/utils";
import PlotDeleteDialog, { PlotDeleteDialogProps } from "@/components/ui/PlotDeleteDialog.vue";
import isMobile from "ismobilejs";

const DisplayFormat = {
  /** 横 */
  HORIZONTAL: "horizontal",
  /** 縦 */
  VERTICAL: "vertical",
} as const;
type DisplayFormat = typeof DisplayFormat[keyof typeof DisplayFormat];

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    ButtonRound,
    HamburgerMenu,
  },
  props: {
    novelId: String,
    plotId: String,
    plot: Object,
  },
  computed: {
    plotName() {
      const { plotId, plot } = this;

      if (plotId) return (plot as SubPlot).name;
      return "全体プロット";
    },
    groupTitles() {
      return ["起", "承", "転", "結"];
    },
    getMode() {
      let mode = "起承転結";
      switch (this.plot.mode) {
        case "johakyu":
          mode = "序破急";
          break;
        case "custom":
          mode = "カスタム";
          break;
      }
      return mode;
    },
    hamburgerMenuItems() {
      const { plotId, changeMode, downloadCsv, switchDisplayFormat, deletePlot, isPC } = this;

      const hamburgerMenuItems: Item[] = [
        {
          name: "モードの変更",
          icon: "cog",
          callback() {
            changeMode();
          },
        },
        {
          name: "CSVダウンロード",
          icon: "tray-arrow-down",
          callback() {
            downloadCsv();
          },
        },
      ];

      if (isPC) {
        const switchDisplayFormatMenu: Item = {
          name: "縦横表示の切替",
          icon: "swap",
          callback() {
            switchDisplayFormat();
          },
        };
        hamburgerMenuItems.push(switchDisplayFormatMenu);
      }

      if (plotId) {
        const deletePlotMenu: Item = {
          name: "プロットを削除",
          icon: "delete",
          color: "#e87474",
          fontStyle: {
            color: "#e87474",
            fontWeight: "bold",
          },
          callback() {
            deletePlot();
          },
        };
        hamburgerMenuItems.push(deletePlotMenu);
      }

      return hamburgerMenuItems;
    },
    displayFormat() {
      const { $store } = this;
      return $store.getters["plotModule/displayFormat"];
    },
    isPC() {
      return !isMobile().any;
    },
  },
  methods: {
    changeMode() {
      const { $router, novelId, plotId, plot } = this;

      if (plotId) {
        $router.push({
          name: "plotChange",
          params: { novelId, plotId },
          query: { mode: plot.mode || "kishoutenketsu" },
        });
      } else {
        $router.push({
          name: "plotChange",
          params: { novelId },
          query: { mode: plot.mode || "kishoutenketsu" },
        });
      }
    },
    async downloadCsv() {
      const { plot, plotName } = this;
      const plotGroupName = plot.plotGroups.map((plotGroup) => plotGroup.name);
      const plotGroupDescription = plot.plotGroups.map((plotGroup) => plotGroup.description);
      let input = [plotGroupName, plotGroupDescription];

      let plotContentMaxNum = 0;
      plot.plotGroups.forEach((plotGroup) => {
        if (plotContentMaxNum < plotGroup.plots.length) {
          plotContentMaxNum = plotGroup.plots.length;
        }
      });
      for (let i = 0; i < plotContentMaxNum; i++) {
        input.push(plot.plotGroups.map((plotGroup) => (plotGroup.plots[i] ? plotGroup.plots[i].text : "")));
      }

      const csv = await (stringify as any)(input);

      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const blob = new Blob([bom, "\uFEFF" + csv], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${format(new Date(), "YYYYMMDD")}_Nolaプロット_${plotName}.csv`;
      link.click();
    },
    switchDisplayFormat() {
      const { $store } = this;
      const { dispatch } = $store;

      dispatch("plotModule/switchDisplayFormat");
    },
    deletePlot() {
      const { novelId, plotId } = this;

      const plotDeleteDialog = new Dialog(PlotDeleteDialog);
      const data: PlotDeleteDialogProps = { novelId, plotId: plotId! };
      plotDeleteDialog.show(data);
    },
  },
});

interface Props {
  novelId: string;
  plotId?: string;
  plot: Plot | SubPlot;
}

interface Data {}

interface Computed {
  plotName: string;
  groupTitles: string[];
  getMode: string;
  hamburgerMenuItems: Item[];
  displayFormat: DisplayFormat;
  isPC: boolean;
}

interface Methods {
  changeMode(): void;
  downloadCsv(): void;
  switchDisplayFormat(): void;
  deletePlot(): void;
}
